<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <app-cabecera
            ref="cabecera"
            :inicializando="inicializando"
            :noValidar="noValidar">
          </app-cabecera>

          <app-montos
            v-if="!ordenesProveedor && !remitos"
            ref="montos"
            :noValidar="noValidar"
            :monedas="monedas"
            :monedasList="monedasList">
          </app-montos>

          <b-card header="Ordenes del Proveedor" v-if="ordenesProveedor">
            <app-moneda
              ref="moneda"
              :noValidar="noValidar"
              :monedas="monedas"
              :monedasList="monedasList">
            </app-moneda>

            <b-row>
              <b-col xl="12">
                <b-table
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-ordenes-proveedores" 
                    :busy="tableBusy"
                    :items="renglones" 
                    :fields="fields">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaComprobante)="data">
                    {{ data.item.fechaComprobante | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda(data.item.moneda) }}
                  </template>
                  <template v-slot:cell(saldo)="data">
                    {{ data.item.saldo | moneda(data.item.moneda) }}
                  </template>
                  <template v-slot:cell(importeFacturar)="data">
                      <template v-if="data.item.presupuestoCerrado || data.item.disabled">
                        --.--
                      </template>
                      <template v-if="!data.item.presupuestoCerrado & !data.item.disabled">
                        <input 
                          type="number"
                          v-model="data.item.importeFacturar"
                          step="0.01"
                          @focus="$event.target.select()"
                          @keyup.enter.prevent="actualizarImporteFacturar"
                          @change="actualizarImporteFacturar"/>
                        <!-- <input 
                          type="number"
                          v-model="data.item.importeFacturar"
                          step="0.01"
                          @input="actualizarImporteFacturar"/> -->
                      </template>
                  </template>
                </b-table>

                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-ordenes-proveedores totales" 
                    :busy="tableBusy"
                    :items="totalRenglones" 
                    :fields="fieldsTotalRenglones">
                  <template v-slot:cell(total)="data">
                    {{ data.item.total | moneda(monedaNombre) }}
                  </template>
                </b-table>

                <small><span>(*)</span> Presupuesto cerrado </small> 
              </b-col>
            </b-row>
          </b-card>

          <b-card header="Remitos del Proveedor" v-if="remitos">
            <b-row>
              <b-col xl="12">
                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-remitos" 
                    :busy="tableBusy"
                    :items="renglonesRemitos"
                    :fields="fieldsRemitos">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaComprobante)="data">
                    {{ data.item.fechaComprobante | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda }}
                  </template>
                  <template v-slot:cell(importeFacturar)="data">
                    {{ data.item.importeFacturar | moneda }}
                  </template>
                  <template v-slot:cell(selected)="data">
                    <b-form-checkbox
                        v-model="data.item.selected"
                        :value="Boolean(true)"
                        :unchecked-value="Boolean(false)"
                        :disabled="data.item.presupuestoCerrado"
                        @click.native.prevent="seleccionarRemito(data.item)">
                    </b-form-checkbox> 
                  </template>
                </b-table>

                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-remitos totales" 
                    :busy="tableBusy"
                    :items="totalRemitos" 
                    :fields="fieldsTotalRemitos">
                  <template v-slot:cell(total)="data">
                    {{ data.item.total | moneda }}
                  </template>
                </b-table>

                <small><span>(*)</span> Corresponde a un presupuesto cerrado </small> 
              </b-col>
            </b-row>
          </b-card>

          <b-card header="Comisiones del Vendedor" v-if="accesoComisiones && vendedoresComisiones && !ordenesProveedor && !remitos">
            <b-row>
              <b-col xl="12">
                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-comisiones" 
                    :busy="tableBusy"
                    :items="vendedoresComisiones"
                    :fields="fieldsComisiones"
                    :current-page="paginaActualComisiones"
                    :per-page="registrosPorPaginaComisiones">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaVenta)="data">
                    {{ data.item.fechaVenta | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda(data.item.moneda) }}
                  </template>
                  <template v-slot:cell(saldo)="data">
                    {{ data.item.saldo | moneda(data.item.moneda) }}
                  </template>
                  <template v-slot:cell(importeFacturar)="data">
                    <template v-if="data.item.disabled">
                      --.--
                    </template>
                    <template v-if="!data.item.disabled">
                      <input 
                        type="number"
                        v-model="data.item.importeFacturar"
                        step="0.01"
                        @focus="$event.target.select()"
                        @keyup.enter.prevent="actualizarImporteComisiones"
                        @change="actualizarImporteComisiones"/>
                    </template>
                  </template>
                  <template v-slot:cell(opciones)="data">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item 
                          @click.stop="cancelarSaldoComision(data.item)">
                        <i class="fa fa-ban"></i>Cancelar Saldo</b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>

                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-comisiones totales" 
                    :busy="tableBusy"
                    :items="totalComisiones" 
                    :fields="fieldsTotalComisiones">
                  <template v-slot:cell(total)="data">
                    {{ data.item.total | moneda }}
                  </template>
                </b-table>

                <nav>
                  <b-pagination size="sm" 
                    :total-rows="totalRegistrosComisiones" 
                    :per-page="registrosPorPaginaComisiones" 
                    v-model="paginaActualComisiones" prev-text="Prev." next-text="Prox."/>
                </nav>
              </b-col>
            </b-row>
          </b-card>

          <app-totales
            ref="totales"
            :noValidar="noValidar">
          </app-totales>

          <b-card header="Cuentas">
            <app-compra-cuentas
              @agregarCuenta="agregarCuenta"
              @editarCuenta="editarCuenta"
              @borrarCuenta="borrarCuenta">
            </app-compra-cuentas>  
          </b-card>

          <b-card header="Amortización de Gastos" class="card-filter">
            <b-btn class="filter-collapse" 
                variant="primary" 
                size="sm"
                @click.prevent="showOpcionesAmortizacion= !showOpcionesAmortizacion">
              <i :class="showOpcionesAmortizacion ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
            </b-btn>
            <b-collapse id="filtro" class="mt-2" v-model="showOpcionesAmortizacion">
              <b-form>
                <b-form-group
                  label="Plazo"
                  label-for="amortizacionAnios"
                  :label-cols="1"
                  description="Plazo de amortización en años"
                  horizontal>
                  <b-form-input 
                    id="amortizacionAnios"
                    v-model.trim="$v.amortizacionAnios.$model" 
                    :state="amortizacionAniosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="amortizacionAniosFeedback">
                    {{ amortizacionAniosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-form>
            </b-collapse>
          </b-card>

          <b-form-group
            label-for="observaciones">
            <b-form-textarea
              id="observaciones"
              v-model="$v.observaciones.$model" 
              rows="3"
              max-rows="6"
              :state="observacionesValidas"
              @blur.native="validate">
            </b-form-textarea>
            <b-form-invalid-feedback id="observacionesFeedback">
              {{ observacionesInvalidasMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="compraCuentaModal" 
        title="Información de la Cuenta"
        header-bg-variant= "light" 
        hide-footer
        hide-header-close
        modal-class="modalABM"
        lazy>
      <app-compra-cuenta
        :cuentas="planCuentas" 
        :cuentasList="planCuentasList"
        @updateCompraCuenta="updateCompraCuenta"
        @closeCompraCuenta="closeCompraCuentaModal">
      </app-compra-cuenta>  
    </b-modal>

    <b-modal ref="compraDatosModal" 
        title="Datos del Comprobante"
        header-bg-variant= "light" 
        hide-footer
        hide-header-close
        modal-class="modalABM"
        lazy>
      <app-compra-datos
        :viaticoId="viaticoId"
        @closeCompraDatos="closeCompraDatos">
      </app-compra-datos>  
    </b-modal>

    <b-modal ref="cancelacionSaldoComisionModal" 
        title="Importe a Cancelar"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importe-cancelacion-saldo
        :params="{
          importe: comisionCancelar.importe
        }"
        @save="saveCancelacionSaldoComision"
        @close="closeCancelacionSaldoComision">
      </app-importe-cancelacion-saldo>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import { required, decimal, minValue, maxValue, numeric, maxLength, minLength, between } from 'vuelidate/lib/validators';
import ABMButtons from '../shared/abmButtons.vue';
import CompraCuenta from './CompraCuenta.vue'
import CompraCuentas from './CompraCuentas.vue'
import Cabecera from './Cabecera.vue'
import Montos from './Montos.vue'
import Moneda from './Moneda.vue'
import Totales from './Totales.vue'
import CompraDatos from './CompraDatos.vue'
import ImporteCancelacionSaldo from '../vendedores/CancelacionSaldo.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

export default {
  name: 'ABM',
  components: {
    appCompraCuenta: CompraCuenta,
    appCompraCuentas: CompraCuentas,
    appABMButton: ABMButtons,
    appCabecera: Cabecera,
    appMontos: Montos,
    appMoneda: Moneda,
    appTotales: Totales,
    appCompraDatos: CompraDatos,
    appImporteCancelacionSaldo: ImporteCancelacionSaldo,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],  
  props: {
    ordenesProveedor: {
      type: Boolean,
      default: false
    },
    ordenFacturacionLogisticaId: {
      type: Number,
      default: 0
    },
    remitos: {
      type: Boolean,
      default: false
    },
    // viaticoId: {
    //   type: Number,
    //   default: 0
    // },
  },
  data () {
    return {
      key: 115500,

      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      noValidar: true,
      amortizacionAniosValido: null,
      amortizacionAniosInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      fields: [
        {
            key: 'id',
            label: 'Nro.Orden',
            sortable: true
        },
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        {
            key: 'presupuesto',
        },
        { key: 'importe', class: "text-right" },
        { key: 'saldo', class: "text-right" },
        { 
          key: 'importeFacturar', 
          label: 'Facturar',
          class: "text-right" 
        },
      ],

      fieldsTotalRenglones: [
        { key: 'col0' },
        { key: 'col1' },
        { key: 'col2' },
        { key: 'col3' },
        { 
          key: 'col4', 
          class: 'text-right' 
        },
        { 
          key: 'total', 
          class: 'text-right' 
        },
      ],

      fieldsRemitos: [
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        { key: 'comprobante' },
        { key: 'destino' },
        { 
          key: 'importe', 
          class: 'text-right' 
        },
        { 
          key: 'importeFacturar',
          label: 'Saldo',
          class: 'text-right' 
        },
        { 
          key: 'selected',
          label: '',
          class: 'text-center'
        }
      ],

      fieldsTotalRemitos: [
        { key: 'col0' },
        { key: 'col1' },
        { 
          key: 'col2',
          class: 'text-right' 
        },
        {
          key: 'col3',
          class: 'text-right' 
        },
        { 
          key: 'total', 
          class: 'text-right' 
        },
        { key: 'col5' }
      ],

      fieldsComisiones: [
        { 
          key: 'presupuestoNumero',
          label: 'Nro.'
        },
        { 
          key: 'presupuestoInterno',
          label: 'Presupuesto'
        },
        { 
          key: 'fechaVenta',
          label: 'Fecha Venta'
        },
        { 
          key: 'venta',
          label: 'Venta'
        },
        { 
          key: 'importe', 
          class: 'text-right' 
        },
        { 
          key: 'saldo', 
          class: 'text-right' 
        },
        { 
          key: 'importeFacturar', 
          label: 'Facturar',
          class: "text-right" 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      fieldsTotalComisiones: [
        { key: 'col0' },
        { key: 'col1' },
        { key: 'col2' },
        { key: 'col3' },
        { 
          key: 'col4',
          class: 'text-right' 
        },
        { key: 'col5' },
        { 
          key: 'total', 
          class: 'text-right' 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      inicializando: Boolean(false),
      tableBusy: false,
      readOnly: Boolean(true),
      showOpcionesAmortizacion: false,
      viaticoId: 0,

      comisionCancelar: {
        presupuestoInternoId: 0,
        vendedorId: 0,
        ventaId: 0,
        importe: 0
      },

      monedas: [],
      monedasList: [],
      planCuentas: [],
      planCuentasList: [],

      accesoComisiones: false,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'periodo',
      'periodoMesNombre',
      'periodoAnio',
      'comprobanteTipo',
      'comprobanteTipoNombre',
      'formulario',
      'moneda',
      'monedaNombre',
      'cuentas',
      'amortizacionAnios',
      'observaciones',
      'renglones',
      'renglonesRemitos',
      'percepcionesProvinciales',
      'vendedoresComisiones',

      'montoOrdenesProveedores',
      'montoRemitos',
      'montoComisiones',
      'paginaActualComisiones',
      'registrosPorPaginaComisiones',
      'totalRegistrosComisiones',
      'totalPaginasComisiones',

      'cuentaSelected',
      'comprobantesTipos',
      'comprobantesTiposList',

      'paisId'
    ]),
    totalRenglones() {
      let totales = [];

      totales.push({
        col0: '',
        col1: '',
        col2: '',
        col3: '',
        col4: 'Total',
        total: this.montoOrdenesProveedores
      })

      return totales;
    },
    totalRemitos() {
      let totales = [];

      totales.push({
        col0: '',
        col1: '',
        col2: 'Total',
        total: this.montoRemitos,
        col4: ''
      })

      return totales;
    },
    totalComisiones() {
      let totales = [];

      totales.push({
        col0: '',
        col1: '',
        col2: '',
        col3: '',
        col4: '',
        col5: 'Total',
        total: this.montoComisiones,
      })

      return totales;
    }
  },
  created() {
    this.getDatosAdicionales();
    
    let compraId = 0;
    this.viaticoId = 0;

    if (this.$route.params){
      if (this.$route.params.id){
        compraId = this.$route.params.id;
      }
      if (this.$route.params.viaticoId){
        this.viaticoId = this.$route.params.viaticoId;
      }
    }

    let params = {
      compraId,
      ordenesProveedor: this.ordenesProveedor,
      remitos: this.remitos,
      viaticoId: this.viaticoId
    }

    this.inicializando = true;
    this.showSpinner();
    this.$store.dispatch('compra/inicializar', params)
      .then(() => {
        if (!this.ordenesProveedor & !this.remitos & this.paisId == 1) {
          this.$refs.compraDatosModal.show();
        } else {
          this.inicializando = false;
        }
      })
      .finally(() => this.hideSpinner());

    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
      case 21: /* Responsable de Finanzas y Proveedores */
        this.accesoComisiones = true;
        break;
    }
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.monedas = [
        { id: 101, nombre: 'PESOS' },
        { id: 102, nombre: 'DOLARES' },
      ];
      this.monedasList = ['PESOS', 'DOLARES'];

      this.planCuentas = [];
      this.planCuentasList = [];
      this.$store.dispatch('cuentas/getList')
        .then(() => {
          this.planCuentas = this.$store.getters['cuentas/list']
          this.planCuentasList = this.$store.getters['cuentas/selectList']

          if (Array.isArray(this.planCuentasList) && this.planCuentasList.length > 0) {
            this.planCuentasList.sort((a, b) => a.localeCompare(b))
          }
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la información de cuentas.')));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "amortizacionAnios" || validarTodos) {
        if (this.$v.amortizacionAnios.$error) {
          this.amortizacionAniosValido = false;
          if (!this.$v.amortizacionAnios.numeric) {
            this.amortizacionAniosInvalidoMsj = 'El plazo de amortización en años debe ser un valor numérico';
          }
        } else {
          this.amortizacionAniosValido = null;
          this.amortizacionAniosInvalidoMsj = '';
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }

      if (validarTodos) {
        this.$refs.cabecera.displayErrores();
      }

      if (validarTodos & !this.ordenesProveedor & !this.remitos) {
        this.$refs.montos.displayErrores();
      }

      if (validarTodos) {
        this.$refs.totales.displayErrores();
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      if (!this.$refs.cabecera.save()) {
        save = false;
      }
      
      if (!this.ordenesProveedor & !this.remitos) {
        if (!this.$refs.montos.save()) {
          save = false;
        }
      }

      if (!this.$refs.totales.save()) {
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('compra/save')
            .then(() => this.showModalMsj('El comprobante se registró con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.go(-1);
    },

    agregarCuenta(item) {
      this.cuentaSelected = null
      this.$refs.compraCuentaModal.show()
    },
    editarCuenta(item) {
      this.cuentaSelected = item
      this.$refs.compraCuentaModal.show()
    },
    borrarCuenta(item) {
      this.cuentaSelected = item
      this.$store.dispatch('compra/deleteCuenta')
    },

    updateCompraCuenta(compraCuenta) {
      this.$store.dispatch('compra/setCuenta', compraCuenta)
      this.$refs.compraCuentaModal.hide()
    },
    closeCompraCuentaModal() {
      this.$refs.compraCuentaModal.hide()
    },

    actualizarImporteFacturar() {
      this.tableBusy = true;
      this.$store.dispatch('compra/calcularTotalOrdenes')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableBusy = false);
    },
    seleccionarRemito(item) {
      if (!item.presupuestoCerrado) {
        item.selected = !item.selected;

        this.tableBusy = true;
        this.$store.dispatch('compra/calcularTotalRemitos')
          .then(() => this.tableBusy = false)
          .catch(error => this.showErrorMsj(error));
      }
    },
    seleccionarComision(item) {
      item.selected = !item.selected;

      this.tableBusy = true;
      this.$store.dispatch('compra/calcularTotalComisiones')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    actualizarImporteComisiones() {
      this.tableBusy = true;
      this.$store.dispatch('compra/calcularTotalComisiones')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableBusy = false);
    },
    cancelarSaldoComision(item) {
      this.comisionCancelar.presupuestoInternoId = item.presupuestoInternoId;
      this.comisionCancelar.vendedorId = item.vendedorId;
      this.comisionCancelar.ventaId = item.ventaId;
      this.comisionCancelar.importe = item.saldoComision;
      this.comisionCancelar.observaciones = '';
      
      /* Habilitamos la edición del importe a cancelar */
      this.$refs.cancelacionSaldoComisionModal.show();
    },
    saveCancelacionSaldoComision(params) {
      if (this.comisionCancelar.importe < params.importe) {
        this.showModalMsj('El importe a cancelar no puede ser mayor al saldo de la comisión seleccionada', null, null, 'light');
        return;
      }

      this.comisionCancelar.importe = params.importe;
      this.comisionCancelar.observaciones = params.observaciones;

      this.$refs.cancelacionSaldoComisionModal.hide();

      this.showSpinner();
      this.$store.dispatch('presupuestosinternos/cancelarSaldoVendedorComision', this.comisionCancelar)
        .then(() => {
          return this.$store.dispatch('compra/updateVendedorComision', this.comisionCancelar);
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());

      // this.showModalConfirm('¿Desea cancelar el importe ingresado del saldo del presupuesto seleccionado?', 
      //       this.cancelarSaldoComisionVendedor, 'Si', null, 'No')
    },
    // cancelarSaldoComisionVendedor() {
    //   this.showSpinner();
    //   this.$store.dispatch('presupuestosinternos/cancelarSaldoVendedorComision', this.comisionCancelar)
    //     .then(() => {
    //       return this.$store.dispatch('compra/updateVendedorComision', this.comisionCancelar);
    //     })
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // },
    closeCancelacionSaldoComision(){
      this.$refs.cancelacionSaldoComisionModal.hide();
    },

    closeCompraDatos() {
      this.$refs.compraDatosModal.hide();
      this.inicializando = false;
    }
  },
  validations: {
    amortizacionAnios: {
      numeric
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  },
}
</script>

<style>
.compra-ordenes-proveedores table td[aria-colindex="1"] {
  width: 10%;
}
.compra-ordenes-proveedores table td[aria-colindex="2"] {
  width: 10%;
}
.compra-ordenes-proveedores table td[aria-colindex="3"] {
  width: 48%;
}
.compra-ordenes-proveedores table td[aria-colindex="4"],
.compra-ordenes-proveedores table td[aria-colindex="5"],
.compra-ordenes-proveedores table td[aria-colindex="6"] {
  width: 10%;
}

.compra-remitos table td[aria-colindex="1"] {
  width: 15%;
}
.compra-remitos table td[aria-colindex="2"] {
  width: 15%;
}
.compra-remitos table td[aria-colindex="3"] {
  width: calc(50% - 60px);
}
.compra-remitos table td[aria-colindex="4"] {
  width: 10%;
}
.compra-remitos table td[aria-colindex="5"] {
  width: 10%;
}
.compra-remitos table td[aria-colindex="6"] {
  width: 60px;
}

.compra-comisiones table td {
  padding-top: 10px !important;
}
.compra-comisiones table td[aria-colindex="1"] {
  width: 6%;
}
.compra-comisiones table td[aria-colindex="2"] {
  width: calc(42% - 30px);
}
.compra-comisiones table td[aria-colindex="3"] {
  width: 10%;
}
.compra-comisiones table td[aria-colindex="4"] {
  width: 12%;
}
.compra-comisiones table td[aria-colindex="5"] {
  width: 10%;
}
.compra-comisiones table td[aria-colindex="6"] {
  width: 10%;
}
.compra-comisiones table td[aria-colindex="7"] {
  width: 10%;
}
.compra-comisiones table td[aria-colindex="8"] {
  width: 30px;
}

.compras-abm .registro-ordenes.totales table {
  font-weight: bolder;
  margin-top: 20px;
}
.compras-abm .registro-ordenes.totales table thead {
  display: none;
}
.compras-abm .registro-ordenes.totales table tr td {
  border-top: none;
}

</style>
